import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Turkish TC Kimlik No generator following Single Responsibility Principle
 */
export class TrGenerator extends BaseGenerator {
  generate() {
    // Generate first 9 digits (first digit cannot be 0)
    const firstDigit = this.randomInt(1, 9);
    const remainingDigits = this.randomDigits(8);
    const first9 = firstDigit + remainingDigits;
    
    // Calculate 10th digit
    let oddSum = 0;
    let evenSum = 0;
    
    for (let i = 0; i < 9; i++) {
      if (i % 2 === 0) {
        oddSum += parseInt(first9[i]);
      } else {
        evenSum += parseInt(first9[i]);
      }
    }
    
    const tenthDigit = ((oddSum * 7) - evenSum) % 10;
    
    // Calculate 11th digit
    const first10 = first9 + tenthDigit;
    let totalSum = 0;
    for (let i = 0; i < 10; i++) {
      totalSum += parseInt(first10[i]);
    }
    
    const eleventhDigit = totalSum % 10;
    
    return first10 + eleventhDigit;
  }
}